"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Header = _interopRequireDefault(require("./styles/Header"));
var _excluded = ["className", "title", "navLeft", "navRight", "leftAlignTitle"];
var Header = function Header(_ref) {
  var className = _ref.className,
    title = _ref.title,
    navLeft = _ref.navLeft,
    navRight = _ref.navRight,
    leftAlignTitle = _ref.leftAlignTitle,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("nav", (0, _extends2["default"])({
    className: (0, _classnames["default"])('application-header', _Header["default"].applicationHeader, className)
  }, props), !!navLeft && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('application-header__links-block', _Header["default"].linksBlock)
  }, navLeft), !leftAlignTitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-spacer"
  }), !!title && /*#__PURE__*/_react["default"].createElement("h1", {
    className: "application-header__title"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-spacer"
  }), !!navRight && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('application-header__links-block', _Header["default"].linksBlock)
  }, navRight));
};
Header.displayName = 'Header';
var _default = exports["default"] = Header;